import { tabIcons, tabTemplate } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import ActivitiesPanel from '../components/ActivitiesPanel';

export default {
  ...tabTemplate('activities', ActivitiesPanel, matchSingleUrl(['activities'])),
  ...tabIcons('comments'),
  access: ({ activities }) => activities.read,
  order: 20,
};
